var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockquote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11532 5.74046C3.31966 4.95774 4.08582 4.5 4.89477 4.5C6.05746 4.5 7 5.44254 7 6.60523V8.32159C7 8.43995 6.9835 8.55774 6.95099 8.67155L6.93919 8.71284C6.79035 9.23376 6.55334 9.72532 6.23845 10.1662L5.43847 11.2861C5.34261 11.4203 5.18783 11.5 5.0229 11.5C4.63076 11.5 4.38493 11.0764 4.57948 10.7359L4.64569 10.62C4.69081 10.5411 4.75417 10.4742 4.8225 10.4142C4.98817 10.2688 5.28571 9.94556 5.28571 9.5C5.28571 9.35008 5.28571 9.21401 5.28571 9.0939C5.28571 8.76582 5.01975 8.5 4.69167 8.5C4.00687 8.5 3.36714 8.11103 3.1703 7.45513C3.07481 7.13697 3 6.79391 3 6.5C3 6.26556 3.0476 5.99986 3.11532 5.74046Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11532 5.74046C9.31966 4.95774 10.0858 4.5 10.8948 4.5C12.0575 4.5 13 5.44254 13 6.60523V8.32159C13 8.43995 12.9835 8.55774 12.951 8.67155L12.9392 8.71284C12.7904 9.23376 12.5533 9.72532 12.2384 10.1662L11.4385 11.2861C11.3426 11.4203 11.1878 11.5 11.0229 11.5C10.6308 11.5 10.3849 11.0764 10.5795 10.7359L10.6457 10.62C10.6908 10.5411 10.7542 10.4742 10.8225 10.4142C10.9882 10.2688 11.2857 9.94556 11.2857 9.5C11.2857 9.35008 11.2857 9.21401 11.2857 9.0939C11.2857 8.76582 11.0198 8.5 10.6917 8.5C10.0069 8.5 9.36714 8.11103 9.1703 7.45513C9.07481 7.13697 9 6.79391 9 6.5C9 6.26556 9.0476 5.99986 9.11532 5.74046Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockquote);
export default __webpack_public_path__ + "static/media/Blockquote.8bf99deb1053dcd0d7cd4389b97fe32b.svg";
export { ForwardRef as ReactComponent };